import { Link } from "@tanstack/react-router";
import { MessageSquareText } from "lucide-react";
import { HomeCard, HomeCardHead } from "@/components/dashboard/home-card";
import { Button } from "@/components/ui/button";
import { useMyUnseenFeedbackCount } from "@/hooks/use-adhoc-feedback";
import { useMyPerson } from "@/hooks/use-persons";

/**
 * "You have new feedback" — feedback someone shared with you since you last
 * opened the Reviews tab on your own profile. The same count drives the badge
 * on that tab; opening it is what clears both.
 *
 * Absent unless there is something new, like the project prompt card above
 * it. A failed count (or the reviews feature being off) also reads as nothing
 * new — this is a nudge, never a blocker.
 */
export function NewFeedbackCard() {
  const { data: me } = useMyPerson();
  const { data: count } = useMyUnseenFeedbackCount(Boolean(me));
  if (!me || !count) return null;

  return (
    <HomeCard>
      <HomeCardHead title="New feedback" />
      <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-3.5">
        <div className="flex items-center gap-3">
          <MessageSquareText className="size-5 shrink-0 text-info" aria-hidden="true" />
          <p className="text-sm">
            {count === 1
              ? "Someone has shared feedback with you."
              : `${count} pieces of feedback have been shared with you.`}
          </p>
        </div>
        <Button asChild size="sm">
          <Link
            to="/dashboard/persons/$personId"
            params={{ personId: me.id }}
            search={{ tab: "reviews" }}
          >
            Read feedback
          </Link>
        </Button>
      </div>
    </HomeCard>
  );
}
